// src/pages/Contact.jsx
import React from 'react';
import Layout from '../components/layout/Layout';
import ContactForm from '../components/forms/ContactForm';
import LocationMap from '../components/maps/LocationMap';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const Contact = () => {
  const contactCards = [
    { icon: <Phone className="h-5 w-5" />, title: 'Phone', content: '+92 314 7776565', href: 'tel:+923147776565' },
    { icon: <Mail className="h-5 w-5" />, title: 'Email', content: 'clinicziadental@gmail.com', href: 'mailto:clinicziadental@gmail.com' },
    { icon: <MapPin className="h-5 w-5" />, title: 'Location', content: 'Topi, Swabi, KPK, Pakistan', href: 'https://www.google.com/maps/place/Zia+Dental+Care/@34.0788388,72.6081485,986m/data=!3m2!1e3!4b1!4m6!3m5!1s0x38defbb4cff22761:0x9fa2b4873b31bea7!8m2!3d34.0788388!4d72.6107234!16s%2Fg%2F11fsx7c8mz?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D' },
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <div className="hero-gradient text-white">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl font-extrabold sm:text-5xl md:text-6xl">
              Contact Us
            </h1>
            <p className="mt-6 max-w-2xl mx-auto text-xl text-blue-100">
              We're here to help. Reach out to us for any questions or concerns.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Contact Information */}
      <section className="relative bg-white">
        <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Contact Info Cards */}
            <div className="space-y-5">
              {contactCards.map((card, i) => (
                <motion.a
                  key={i}
                  href={card.href}
                  target={card.title === 'Location' ? '_blank' : undefined}
                  rel={card.title === 'Location' ? 'noopener noreferrer' : undefined}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.1 }}
                  className="block bg-gray-50 p-6 rounded-xl border border-gray-100 hover:shadow-lg hover:border-blue-100 hover:-translate-y-0.5 transition-all duration-300"
                >
                  <div className="flex items-center">
                    <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-blue-100 text-blue-600">
                      {card.icon}
                    </div>
                    <h3 className="ml-3 text-lg font-semibold text-gray-900">{card.title}</h3>
                  </div>
                  <p className="mt-3 text-gray-500 text-sm">{card.content}</p>
                </motion.a>
              ))}

              {/* Hours */}
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 }}
                className="bg-gray-50 p-6 rounded-xl border border-gray-100"
              >
                <div className="flex items-center">
                  <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-blue-100 text-blue-600">
                    <Clock className="h-5 w-5" />
                  </div>
                  <h3 className="ml-3 text-lg font-semibold text-gray-900">Hours</h3>
                </div>
                <div className="mt-3 space-y-1.5 text-sm text-gray-500">
                  <p>Monday - Thursday: 10:30 AM - 8:00 PM</p>
                  <p>Saturday - Sunday: 10:30 AM - 8:00 PM</p>
                  <p className="text-red-400">Friday: Closed</p>
                </div>
              </motion.div>
            </div>

            {/* Contact Form */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="lg:col-span-2"
            >
              <ContactForm />
            </motion.div>
          </div>

          {/* Map Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="mt-16"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Our Location</h2>
            <div className="rounded-xl overflow-hidden shadow-lg">
              <LocationMap />
            </div>
            <div className="mt-4 text-center text-gray-500 text-sm">
              <p>Visit us at our clinic to experience top-quality dental care</p>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;